// import type { Skill } from './api';
import type { ReactNode } from 'react';
import type {
  BoardRequestType,
  OrganizationProfileRequestType,
  OrganizationSkillRequestType,
  RequestToCreateOrganizationType,
} from './user-organization.types';

export const initialData: WizardData = {
  organization: {
    name: '',
    organization_type: '',
    tenant_type: 'school',
    website: '',
    address: '',
    telephone: '',
  },
  skills: {
    skill_type: '',
    name: '',
    description: '',
  },
  profile: {
    name: '',
    slogan: '',
    address: '',
    email: '',
    website: '',
    about_us: '',
    telephone: '',
    country: '',
  },
  orgLogo: '',
  board: {
    name: '',
    description: '',
    head_of_board: null,
    parent: null,
  },
};

export const steps = ['Organization', 'Profile'];

export type updateFormType = 'organizaion' | 'profile';

export interface WizardData {
  organization: RequestToCreateOrganizationType;
  profile: OrganizationProfileRequestType;
  orgLogo: string | null;
  skills: OrganizationSkillRequestType;
  board: BoardRequestType;
}

export type Step = 1 | 2 | 3;

export interface StepIndicatorProps {
  currentStep: Step;
}

export interface WizardStepsButtonsProps {
  wizardStep: number;
  steps: unknown[];

  isBusy?: boolean;

  step1Ready: boolean;
  step2Ready?: boolean;

  setWizardPrevStep: () => void;
  setWizardNextStep: () => void;
  createOrganization: () => void;

  WizardSteps: number | string;

  createIcon?: ReactNode;
}
